import { render, staticRenderFns } from "./candidateItem.vue?vue&type=template&id=836ddf0a&scoped=true"
import script from "./candidateItem.vue?vue&type=script&lang=ts"
export * from "./candidateItem.vue?vue&type=script&lang=ts"
import style0 from "./candidateItem.vue?vue&type=style&index=0&id=836ddf0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836ddf0a",
  null
  
)

export default component.exports